module.exports = __webpack_public_path__ + "img/bg42.0a7db032.png";